var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from 'ethers';
var _abi = [
    {
        inputs: [
            {
                internalType: 'string',
                name: 'baseURI_',
                type: 'string',
            },
            {
                internalType: 'address',
                name: 'owner_',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'pricePerTokenMint_',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'launchTimestamp_',
                type: 'uint256',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'constructor',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
        ],
        name: 'AirdropSet',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'approved',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
        ],
        name: 'Approval',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'operator',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'bool',
                name: 'approved',
                type: 'bool',
            },
        ],
        name: 'ApprovalForAll',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'assetGeneratorHash',
                type: 'bytes32',
            },
        ],
        name: 'AssetGeneratorHashSet',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'string',
                name: 'baseURI',
                type: 'string',
            },
        ],
        name: 'BaseURISet',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'uint256',
                name: 'drug',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256[]',
                name: 'molecules',
                type: 'uint256[]',
            },
        ],
        name: 'DrugDecomposed',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'previousOwner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
        ],
        name: 'OwnershipAccepted',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'pendingOwner',
                type: 'address',
            },
        ],
        name: 'OwnershipProposed',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'uint256',
                name: 'price',
                type: 'uint256',
            },
        ],
        name: 'PricePerTokenMintSet',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
        ],
        name: 'ProceedsDestinationSet',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'destination',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'ProceedsWithdrawn',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
        ],
        name: 'PromotionAccountSet',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
        ],
        name: 'PromotionAccountUnset',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'from',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
        ],
        name: 'Transfer',
        type: 'event',
    },
    {
        inputs: [],
        name: 'LAUNCH_TIMESTAMP',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'acceptOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
        ],
        name: 'approve',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'assetGeneratorHash',
        outputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'availabilities',
        outputs: [
            {
                internalType: 'uint256[63]',
                name: 'moleculesAvailabilities_',
                type: 'uint256[63]',
            },
            {
                internalType: 'uint256[19]',
                name: 'drugAvailabilities_',
                type: 'uint256[19]',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
        ],
        name: 'balanceOf',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'baseURI',
        outputs: [
            {
                internalType: 'string',
                name: '',
                type: 'string',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256[]',
                name: 'molecules_',
                type: 'uint256[]',
            },
            {
                internalType: 'uint256',
                name: 'drugType_',
                type: 'uint256',
            },
            {
                internalType: 'address',
                name: 'destination_',
                type: 'address',
            },
        ],
        name: 'brew',
        outputs: [
            {
                internalType: 'uint256',
                name: 'drug_',
                type: 'uint256',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'account_',
                type: 'address',
            },
        ],
        name: 'canClaimFreeWater',
        outputs: [
            {
                internalType: 'bool',
                name: 'canClaimFreeWater_',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'destination_',
                type: 'address',
            },
        ],
        name: 'claimWater',
        outputs: [
            {
                internalType: 'uint256',
                name: 'molecule_',
                type: 'uint256',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'compactStates',
        outputs: [
            {
                internalType: 'uint256',
                name: 'compactState1_',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'compactState2_',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'compactState3_',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'contractURI',
        outputs: [
            {
                internalType: 'string',
                name: 'contractURI_',
                type: 'string',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'drug_',
                type: 'uint256',
            },
        ],
        name: 'decompose',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'drugAvailabilities',
        outputs: [
            {
                internalType: 'uint256[19]',
                name: 'availabilities_',
                type: 'uint256[19]',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'drugsAvailable',
        outputs: [
            {
                internalType: 'uint256',
                name: 'drugsAvailable_',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
        ],
        name: 'getApproved',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'drugType_',
                type: 'uint256',
            },
        ],
        name: 'getAvailabilityOfDrug',
        outputs: [
            {
                internalType: 'uint256',
                name: 'availability_',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'moleculeType_',
                type: 'uint256',
            },
        ],
        name: 'getAvailabilityOfMolecule',
        outputs: [
            {
                internalType: 'uint256',
                name: 'availability_',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'molecule_',
                type: 'uint256',
            },
        ],
        name: 'getDrugContainingMolecule',
        outputs: [
            {
                internalType: 'uint256',
                name: 'drug_',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'drug_',
                type: 'uint256',
            },
        ],
        name: 'getMoleculesWithinDrug',
        outputs: [
            {
                internalType: 'uint256[]',
                name: 'molecules_',
                type: 'uint256[]',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'drugType_',
                type: 'uint256',
            },
        ],
        name: 'getRecipeOfDrug',
        outputs: [
            {
                internalType: 'uint8[]',
                name: 'recipe_',
                type: 'uint8[]',
            },
        ],
        stateMutability: 'pure',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address[]',
                name: 'destinations_',
                type: 'address[]',
            },
            {
                internalType: 'uint256[]',
                name: 'amounts_',
                type: 'uint256[]',
            },
        ],
        name: 'giveMolecules',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address[]',
                name: 'destinations_',
                type: 'address[]',
            },
            {
                internalType: 'uint256[]',
                name: 'amounts_',
                type: 'uint256[]',
            },
        ],
        name: 'giveWaters',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'operator',
                type: 'address',
            },
        ],
        name: 'isApprovedForAll',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'moleculeAvailabilities',
        outputs: [
            {
                internalType: 'uint256[63]',
                name: 'availabilities_',
                type: 'uint256[63]',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'moleculesAvailable',
        outputs: [
            {
                internalType: 'uint256',
                name: 'moleculesAvailable_',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'name',
        outputs: [
            {
                internalType: 'string',
                name: '',
                type: 'string',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'owner',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
        ],
        name: 'ownerOf',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'pendingOwner',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'pricePerTokenMint',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'proceedsDestination',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'newOwner_',
                type: 'address',
            },
        ],
        name: 'proposeOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'destination_',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'quantity_',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'minQuantity_',
                type: 'uint256',
            },
        ],
        name: 'purchase',
        outputs: [
            {
                internalType: 'uint256[]',
                name: 'molecules_',
                type: 'uint256[]',
            },
        ],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'from',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
        ],
        name: 'safeTransferFrom',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'from',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
            {
                internalType: 'bytes',
                name: 'data',
                type: 'bytes',
            },
        ],
        name: 'safeTransferFrom',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'operator',
                type: 'address',
            },
            {
                internalType: 'bool',
                name: 'approved',
                type: 'bool',
            },
        ],
        name: 'setApprovalForAll',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'assetGeneratorHash_',
                type: 'bytes32',
            },
        ],
        name: 'setAssetGeneratorHash',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'string',
                name: 'baseURI_',
                type: 'string',
            },
        ],
        name: 'setBaseURI',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'pricePerTokenMint_',
                type: 'uint256',
            },
        ],
        name: 'setPricePerTokenMint',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'proceedsDestination_',
                type: 'address',
            },
        ],
        name: 'setProceedsDestination',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address[]',
                name: 'accounts_',
                type: 'address[]',
            },
        ],
        name: 'setPromotionAccounts',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes4',
                name: 'interfaceId',
                type: 'bytes4',
            },
        ],
        name: 'supportsInterface',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'symbol',
        outputs: [
            {
                internalType: 'string',
                name: '',
                type: 'string',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'index',
                type: 'uint256',
            },
        ],
        name: 'tokenByIndex',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'index',
                type: 'uint256',
            },
        ],
        name: 'tokenOfOwnerByIndex',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'tokenId_',
                type: 'uint256',
            },
        ],
        name: 'tokenURI',
        outputs: [
            {
                internalType: 'string',
                name: 'tokenURI_',
                type: 'string',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'owner_',
                type: 'address',
            },
        ],
        name: 'tokensOfOwner',
        outputs: [
            {
                internalType: 'uint256[]',
                name: 'tokenIds_',
                type: 'uint256[]',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'totalSupply',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'from',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
        ],
        name: 'transferFrom',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address[]',
                name: 'accounts_',
                type: 'address[]',
            },
        ],
        name: 'unsetPromotionAccounts',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'withdrawProceeds',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
];
var _bytecode = '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';
var isSuperArgs = function (xs) { return xs.length > 1; };
var XSublimatio__factory = /** @class */ (function (_super) {
    __extends(XSublimatio__factory, _super);
    function XSublimatio__factory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = this;
        if (isSuperArgs(args)) {
            _this = _super.apply(this, args) || this;
        }
        else {
            _this = _super.call(this, _abi, _bytecode, args[0]) || this;
        }
        _this.contractName = 'XSublimatio';
        return _this;
    }
    XSublimatio__factory.prototype.deploy = function (baseURI_, owner_, pricePerTokenMint_, launchTimestamp_, overrides) {
        return _super.prototype.deploy.call(this, baseURI_, owner_, pricePerTokenMint_, launchTimestamp_, overrides || {});
    };
    XSublimatio__factory.prototype.getDeployTransaction = function (baseURI_, owner_, pricePerTokenMint_, launchTimestamp_, overrides) {
        return _super.prototype.getDeployTransaction.call(this, baseURI_, owner_, pricePerTokenMint_, launchTimestamp_, overrides || {});
    };
    XSublimatio__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    XSublimatio__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    XSublimatio__factory.createInterface = function () {
        return new utils.Interface(_abi);
    };
    XSublimatio__factory.connect = function (address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    };
    XSublimatio__factory.bytecode = _bytecode;
    XSublimatio__factory.abi = _abi;
    return XSublimatio__factory;
}(ContractFactory));
export { XSublimatio__factory };
//# sourceMappingURL=XSublimatio__factory.js.map